// extracted by mini-css-extract-plugin
export default {"tab_list":"burger-ingredients-tabs_tab_list__vv4Qd"};